import {
  FaMap,
  FaCommentDots,
  FaUsers,
  FaToolbox,
  FaUser,
  FaEllipsisH,
} from 'react-icons/fa';
import { GiDeerTrack, GiCampfire } from 'react-icons/gi';

/**
 * Shared section icons for desktop rail, mobile bottom bar, and More dial.
 * Keep these in sync so mobile never drifts back to prototype glyphs.
 */
export const NAV_SECTION_ICONS = {
  ground: FaMap,
  clubs: GiCampfire,
  hunts: GiDeerTrack,
  community: FaUsers,
  profile: FaUser,
  toolkit: FaToolbox,
  messages: FaCommentDots,
  more: FaEllipsisH,
};
